import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-video-icon]',
  template: `
    <svg:path
      d="M4 7C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H15C15.5523 17 16 16.5523 16 16V8C16 7.44772 15.5523 7 15 7H4ZM1 8C1 6.34315 2.34315 5 4 5H15C16.6569 5 18 6.34315 18 8V9.58579L20.4393 7.14645C21.3843 6.20149 23 6.87076 23 8.20711V15.7929C23 17.1293 21.3843 17.7985 20.4393 16.8536L18 14.4142V16C18 17.6569 16.6569 19 15 19H4C2.34315 19 1 17.6569 1 16V8ZM18.4142 12L21 14.5858V9.41422L18.4142 12Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
